<template>

  <el-row>
    <el-form :model="userNotificationData" ref="UserNotificationChangeForm" :rules="rules"  label-width="220px" >
      <el-col>
        <h2>User Approval Role</h2>
        <el-row :gutter="20">
          <el-col :lg="6">
            User Role ID:  {{roleData.id}}
          </el-col>
        </el-row>
        <hr />
        <el-row :gutter="24">
          <el-col :lg="6">
            <el-form-item label="Active" prop="isActive">
              <el-checkbox v-model="roleData.isActive" :disabled="nonAdmin"></el-checkbox>
            </el-form-item>
          </el-col>
          <!--<el-col :lg="1">
            <tool-tip-popup text="Note: Determines if this user role is active or ignored when determining approvals."></tool-tip-popup>
          </el-col>-->
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="12">
            <el-form-item label="Division" prop="peaDivisionId">
              <division-dropdown :disabled="disabled" v-model="roleData.peaDivisionId" :inputModel="roleData.peaDivisionId"></division-dropdown>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :lg="12">
            <el-form-item label="Approval Role" prop="roleId">
              <role-dropdown :disabled="disabled" v-model="roleData.roleId" :inputModel="roleData.roleId"></role-dropdown>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :lg="12">
            <el-form-item label="User" prop="userId">
              <user-dropdown v-model="roleData.userId" :inputModel="roleData.userId" :disabled="nonAdmin"></user-dropdown>
            </el-form-item>
          </el-col>
        </el-row>

    <el-row>
      <el-col>
        <el-alert v-if="alertTitle !== ''"
        :title="alertTitle"
        :type="alertType"
        :description="callInfo"
        :closable="false"
        show-icon>
        </el-alert>
      </el-col>
    </el-row>
</el-col>
</el-form>
    <div v-if="this.creating == false">
      <button class="btn btn-primary" @click="updateNotification()" :disabled="nonAdmin">Update User Notification</button>
   </div>
</el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'changeNotificationListener',
  props: {
    userNotificationId: {
      default: 0
    },
    disabled: {
      default: false
    },
    creating: {
      default: false
    }
  },
  data () {
    return {
      userName: '',
      nonAdmin: true,
      isLoading: false,
      alertType: '',
      alertTitle: '',
      callInfo: '',
      clearable: true,
      updatedNotificationId: 0,
      userNotificationData: {
        id: 0,
        peaNotificationId: '',
        userId: '',
        peaDivisionId: '',
        userName: '',
        userFullName: '',
        peaNotificationDescriptione: '',
        statusName: '',
        divisionName: '',
        statusId: 0,
        divisionId: 0
      },
      rules: {
        peaNotificationId: [
          { type: 'number', required: true, message: 'Please pick a notification', trigger: 'visible-change' }
        ],
        userId: [
          { type: 'number', required: true, message: 'Please pick a User', trigger: 'visible-change' }
        ],
        peaDivisionId: [
          { type: 'number', required: true, message: 'Please pick a Division', trigger: 'visible-change' }
        ]
      }
    }
  },
  methods: {
    fetchData () {
      if (this.updatedNotificationId === 0) {
        this.updatedNotificationId = this.userNotificationId
      }
      var call = '/getPEANotificationListener/' + this.updatedNotificationId
      this.$axios.get(call).then(response => {
        this.roleData = response.data
        this.nonAdmin = false
      })
      this.updatedUserRoleId = 0
    },
    formSubmit () {
      // eslint-disable-next-line
      if (this.userRoleId <= 0) {
        return this.addApprovalUserRole()
      } else {
        return this.updateApprovalRole()
      }
    },
    checkIfValid () {
      this.$refs['UserNotificationChangeForm'].validate((valid) => {
        if (valid) {
          this.$parent.$emit('createUserRoleValidation', true)
        } else {
          this.$parent.$emit('createUserRoleValidation', false)
          helperMethods.showNotification(this.$parent, 'Invalid approval user role requirements', 'Please check approval user role section for invalid inputs.', 'warning', 30000, 'Please check form for invalid inputs.')
        }
      })
    },
    startUp () {
      // eslint-disable-next-line
      if (this.$store.getters.isAdmin) {
        if (this.userRoleId !== 0) {
          this.fetchData()
          this.disabled = true
        } else {
          this.disabled = false
        }
        this.nonAdmin = false
      } else {
        this.nonAdmin = true
        this.disabled = true
      }
    },
    addApprovalUserRole () {
      var call = '/updatePEANotificationListener/' + this.notificationId
      // this.peaCore.createdByUserId = this.$store.getters.userId
      return new Promise((resolve, reject) => {
        this.$axios.post(call, this.roleData).then(response => {
          this.userNotificationData.id = response.data.id
          this.updatedUserRoleId = response.data.id
          resolve(response)
        })
          .catch(response => {
            reject(response)
          })
      })
    },
    updateNotification () {
      this.$refs['ApprovalUserRoleChangeForm'].validate((valid) => {
        if (valid) {
          var call = '/updatePEANotificationListener/' + this.notificationId
          this.$axios.post(call, this.userNotificationData).then(response => {
            if (response.data.id !== 0) {
              this.userNotificationData.id = response.data.id
              this.updatedNotificationId = response.data.id
              this.fetchData()
            }
            this.isLoading = false
            helperMethods.showNotification(this, 'PEA User Notification successfully updated', 'PEA User Notification Update', 'success', 10000)
          })
            .catch(response => {
              helperMethods.showNotification(this, 'Error updating PEA User Notification Information', response, 'error', 30000)
            // helperMethods.showNotification(this.$parent, 'Invalid Comment', 'Please add Comment text', 'warning', 10000, '')
            })
        }
      })
    }
  },
  mounted () {
    this.startUp()
  },
  watch: {
    // watch for route change - going from rule/4 to rule/0
    '$route': 'startUp'
  }
}
</script>
